import config from "config/config";

export const isOldAlicUlPolicy = (policy) => {
  const { product } = policy || {};
  const policyType = product?.type;
  const OLD_ALIC_PRODUCT_TYPE = config.OLD_ALIC_PRODUCT_TYPE?.split(",");

  if (!policyType || typeof policyType !== "string") return false;
  return OLD_ALIC_PRODUCT_TYPE.includes(policyType.trim().toUpperCase());
};
